var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['wh100', _vm.device],attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view',{staticClass:"pages"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }